<template>
  <aside class="community-tools card mobile:radius-zero">
    <p class="p-small uppercase fw-semi t-grey mn-b-regular">Наши инструменты</p>

    <router-link
      v-for="tool in tools"
      :key="tool.to"
      :to="tool.to"
      class="community-tools__item flex flex-nowrap flex-v-center gap-small pd-small radius-small mn-b-thin"
    >
      <span class="community-tools__icon flex-center flex flex-child-default radius-small">
        <Icon :name="tool.icon" color="rgb(var(--main))" class="i-medium" />
      </span>
      <span class="flex flex-column">
        <span class="p-small fw-medium t-black">{{ tool.name }}</span>
        <span class="p-small t-grey mn-t-thin">{{ tool.desc }}</span>
      </span>
    </router-link>
  </aside>
</template>

<script setup>
import Icon from '@martyrs/src/design-system/components/Icon/Icon.vue';

// Лид-магниты: бесплатные AI-инструменты Traffers (SEO_STRATEGY.md §4.9 —
// «мягкий мост»: value-first, без регистрации). Белая карточка с бордером+тенью
// (единая система рельс), пункты — строки icon+текст с ховером (без вложенных
// бордеров — чтобы не было «коробка в коробке»). Описания короткие, чтобы в
// колонке не ломались в кашу.
const tools = [
  {
    to: '/tools/avtootkliki',
    icon: 'applications',
    name: 'Автоотклики на HH.ru',
    desc: 'AI ищет вакансии и откликается',
  },
  {
    to: '/tools/resume-improvement',
    icon: 'resume',
    name: 'AI-разбор резюме',
    desc: 'Найдём слабые места и усилим',
  },
];
</script>

<style scoped lang="scss">
.community-tools {
  box-shadow: var(--elevation-1);
}

.community-tools__item {
  transition: background 0.15s ease;
}

.community-tools__item:last-child {
  margin-bottom: 0;
}

.community-tools__item:hover {
  background: rgba(var(--main), 0.06);
}

.community-tools__icon {
  width: 2.5rem;
  height: 2.5rem;
  background: rgba(var(--main), 0.12);
}
</style>
